import script from "./BillReturn.vue?vue&type=script&setup=true&lang=js"
export * from "./BillReturn.vue?vue&type=script&setup=true&lang=js"

import "./BillReturn.vue?vue&type=style&index=0&id=c702b1ce&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c702b1ce"]])

export default __exports__